import React, { useCallback, useEffect, useMemo, useState } from 'react';

import alert from '../../helpers/alert';
import extractErrorMessage from '../../utils/extractErrorMessage';
import styles from './sheetSync.module.css';
import {
  getSheetSyncHistory,
  getSheetSyncSettings,
  rollbackSheetRun,
  rollbackToSheetRun,
  setSheetAutoSync,
} from '../../api/prices';
import {
  KIND_LABELS,
  STATUS_LABELS,
  canRollback,
  deltaText,
  formatDateTime,
  isBigJump,
  laterRollbackable,
  matchesFilter,
  money,
  summarizeRun,
} from './sheetSyncFormat';

const kindClass = (kind) =>
  [
    styles.kind,
    { created: styles.kindCreated, changed: styles.kindChanged, held: styles.kindHeld, problem: styles.kindProblem }[kind],
  ]
    .filter(Boolean)
    .join(' ');

// ÐÐ²ÑÐ¾ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ñ: Ð¿ÐµÑÐµÐºÐ»ÑÑÐ°ÑÐµÐ»Ñ Ð¶Ð¸Ð²ÑÑ Ð·Ð´ÐµÑÑ, ÑÑÐ´Ð¾Ð¼ Ñ Ð¸ÑÑÐ¾ÑÐ¸ÐµÐ¹ Ð¸ Ð¾ÑÐºÐ°ÑÐ°Ð¼Ð¸ â Ð¾ÑÐºÐ»ÑÑÐ¸ÑÑ ÐµÑ Ð½ÑÐ¶Ð½Ð¾, ÐºÐ¾Ð³Ð´Ð° Ð²Ð¾Ð·Ð²ÑÐ°ÑÐ°ÐµÑÑÑÑ
// Ðº ÑÑÐ°ÑÐ¾Ð¹ Ð²ÐµÑÑÐ¸Ð¸, Ð¸Ð½Ð°ÑÐµ ÑÐ»ÐµÐ´ÑÑÑÐ°Ñ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ° ÑÐ½Ð¾Ð²Ð° Ð¿ÑÐ¸Ð¼ÐµÐ½Ð¸Ñ ÑÐµÐ½Ñ Ð¸Ð· ÑÐ°Ð±Ð»Ð¸ÑÑ
const AutoSyncPanel = ({ settings, busy, onToggle, confirming }) => {
  if (!settings) return null;
  const on = settings.autoSync;
  return (
    <div className={`${styles.autoPanel} ${on ? styles.autoOn : styles.autoOff}`}>
      <div className={styles.autoText}>
        <b>ÐÐ²ÑÐ¾ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ñ: {on ? 'Ð²ÐºÐ»ÑÑÐµÐ½Ð°' : 'Ð²ÑÐºÐ»ÑÑÐµÐ½Ð°'}</b>
        <div className={styles.muted}>
          {on
            ? `Ð¢Ð°Ð±Ð»Ð¸ÑÐ° Ð¿ÑÐ¾Ð²ÐµÑÑÐµÑÑÑ Ð¿ÑÐ¸Ð¼ÐµÑÐ½Ð¾ ÑÐ°Ð· Ð² ${settings.intervalMinutes} Ð¼Ð¸Ð½. ÐÐµÐ·Ð¾Ð¿Ð°ÑÐ½ÑÐµ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ Ð¿ÑÐ¸Ð¼ÐµÐ½ÑÑÑÑÑ ÑÐ°Ð¼Ð¸ Ð¸ Ð¿Ð¸ÑÑÑÑÑ ÑÑÐ´Ð°, ÑÐ¿Ð¾ÑÐ½ÑÐµ Ð¶Ð´ÑÑ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ñ Ð²Ð¾ Ð²ÐºÐ»Ð°Ð´ÐºÐµ Â«Ð¢Ð°Ð±Ð»Ð¸ÑÐ°Â».`
            : 'Ð¦ÐµÐ½Ñ Ð¼ÐµÐ½ÑÑÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ ÐºÐ½Ð¾Ð¿ÐºÐ¾Ð¹ Â«ÐÑÐ¸Ð¼ÐµÐ½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸ÑÂ» Ð²Ð¾ Ð²ÐºÐ»Ð°Ð´ÐºÐµ Â«Ð¢Ð°Ð±Ð»Ð¸ÑÐ°Â». ÐÑÐ»Ð¸ Ð²Ñ Ð²ÐµÑÐ½ÑÐ»Ð¸ÑÑ Ðº ÑÑÐ°ÑÐ¾Ð¹ Ð²ÐµÑÑÐ¸Ð¸, Ð¾ÑÑÐ°Ð²ÑÑÐµ Ð²ÑÐºÐ»ÑÑÐµÐ½Ð½Ð¾Ð¹, Ð¸Ð½Ð°ÑÐµ ÑÐ»ÐµÐ´ÑÑÑÐ°Ñ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ° Ð¿ÑÐ¸Ð¼ÐµÐ½Ð¸Ñ ÑÐµÐ½Ñ Ð¸Ð· ÑÐ°Ð±Ð»Ð¸ÑÑ ÑÐ½Ð¾Ð²Ð°.'}
        </div>
        <div className={styles.muted}>
          {settings.source === 'db'
            ? `ÐÐµÑÐµÐºÐ»ÑÑÐµÐ½Ð¾ Ð½Ð° ÑÐºÑÐ°Ð½Ðµ${settings.changedBy ? `: ${settings.changedBy}` : ''}${settings.changedAt ? `, ${formatDateTime(settings.changedAt)}` : ''}.`
            : 'Ð¡ÐµÐ¹ÑÐ°Ñ Ð´ÐµÐ¹ÑÑÐ²ÑÐµÑ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ° Ð¸Ð· ÐºÐ¾Ð½ÑÐ¸Ð³Ð° ÑÐµÑÐ²ÐµÑÐ°; Ð²ÑÐ±Ð¾Ñ Ð½Ð° ÑÐºÑÐ°Ð½Ðµ ÐµÑ Ð¿ÐµÑÐµÐºÑÐ¾ÐµÑ.'}
        </div>
      </div>
      <button
        type="button"
        className={on ? styles.mini : confirming ? styles.miniDanger : styles.miniPrimary}
        disabled={busy}
        title={on ? 'ÐÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÑÑ Ð¿ÑÐ¾Ð²ÐµÑÐºÑ ÑÐ°Ð±Ð»Ð¸ÑÑ' : 'ÐÐ°Ð¿ÑÑÑÐ¸ÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÑÑ Ð¿ÑÐ¾Ð²ÐµÑÐºÑ ÑÐ°Ð±Ð»Ð¸ÑÑ'}
        onClick={onToggle}
      >
        {on ? 'ÐÑÐºÐ»ÑÑÐ¸ÑÑ' : confirming ? 'Ð¢Ð¾ÑÐ½Ð¾ Ð²ÐºÐ»ÑÑÐ¸ÑÑ?' : 'ÐÐºÐ»ÑÑÐ¸ÑÑ'}
      </button>
    </div>
  );
};

// ÐÐºÐ»Ð°Ð´ÐºÐ° Â«ÐÑÑÐ¾ÑÐ¸ÑÂ»: ÐºÐ°Ð¶Ð´ÑÐ¹ Ð·Ð°Ð¿ÑÑÐº Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸ ÑÐ°Ð±Ð»Ð¸ÑÑ Ð¸ ÐµÐ³Ð¾ Ð´Ð¸ÑÑ â ÐºÐ¾Ð³Ð´Ð°, ÐºÑÐ¾, ÑÑÐ¾ Ð¸ Ð½Ð° ÑÐºÐ¾Ð»ÑÐºÐ¾ Ð¸Ð·Ð¼ÐµÐ½Ð¸Ð»Ð¾ÑÑ.
// ÐÑÑÑÐ´Ð° Ð¶Ðµ Ð¾ÑÐºÐ°Ñ Ð¾Ð´Ð½Ð¾Ð³Ð¾ Ð·Ð°Ð¿ÑÑÐºÐ°, Ð²Ð¾Ð·Ð²ÑÐ°Ñ Ðº Ð²ÐµÑÑÐ¸Ð¸ Ð¸ Ð¿ÐµÑÐµÐºÐ»ÑÑÐ°ÑÐµÐ»Ñ Ð°Ð²ÑÐ¾ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ð¸
const SheetHistory = () => {
  const [runs, setRuns] = useState(null);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(() => new Set());
  const [query, setQuery] = useState('');
  // ÐÑÐºÐ°Ñ Ð¸ Ð²ÐºÐ»ÑÑÐµÐ½Ð¸Ðµ Ð°Ð²ÑÐ¾ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ð¸ Ð¼ÐµÐ½ÑÑÑ ÑÐµÐ½Ñ: Ð²ÑÐ¾ÑÐ¾Ð¹ ÐºÐ»Ð¸Ðº Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´Ð°ÐµÑ, ÑÐµÑÐµÐ· Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ ÑÐµÐºÑÐ½Ð´ ÑÐ±ÑÐ°ÑÑÐ²Ð°ÐµÑÑÑ
  const [confirm, setConfirm] = useState(null);

  const load = useCallback(() => {
    setLoading(true);
    Promise.all([
      getSheetSyncHistory(50).then((res) => setRuns(res.data || [])),
      getSheetSyncSettings()
        .then((res) => setSettings(res.data))
        .catch(() => setSettings(null)),
    ])
      .catch((err) => {
        setRuns((prev) => prev || []);
        alert.error(extractErrorMessage(err) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð¸ÑÑÐ¾ÑÐ¸Ñ');
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    if (confirm == null) return undefined;
    const timer = setTimeout(() => setConfirm(null), 5000);
    return () => clearTimeout(timer);
  }, [confirm]);

  const toggle = (id) =>
    setOpen((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });

  const ask = (kind, id = 0) => {
    if (confirm?.kind === kind && confirm?.id === id) {
      setConfirm(null);
      return true;
    }
    setConfirm({ kind, id });
    return false;
  };

  const rollback = async (runId) => {
    if (!ask('run', runId)) return;
    setBusy(true);
    try {
      const res = await rollbackSheetRun(runId);
      alert.success(`ÐÐ°Ð¿ÑÑÐº Ð¾ÑÐºÐ°ÑÐµÐ½: Ð¿ÑÐ°Ð²Ð¸Ð» ${res.data.rules}, Ð¼Ð°ÑÐ¸Ð½ ${res.data.cars}, Ð½Ðµ ÑÑÐ¾Ð½ÑÑÐ¾ Ð¿ÑÐ°Ð²Ð¸Ð» ${res.data.rulesSkipped}`);
      load();
    } catch (err) {
      alert.error(extractErrorMessage(err) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¾ÑÐºÐ°ÑÐ¸ÑÑ Ð·Ð°Ð¿ÑÑÐº');
    } finally {
      setBusy(false);
    }
  };

  const rollbackTo = async (runId) => {
    if (!ask('to', runId)) return;
    setBusy(true);
    try {
      const res = await rollbackToSheetRun(runId);
      alert.success(
        `ÐÐ¾Ð·Ð²ÑÐ°Ñ Ðº Ð²ÐµÑÑÐ¸Ð¸ Ð²ÑÐ¿Ð¾Ð»Ð½ÐµÐ½: Ð¾ÑÐºÐ°ÑÐµÐ½Ð¾ Ð·Ð°Ð¿ÑÑÐºÐ¾Ð² ${res.data.runs}, Ð¿ÑÐ°Ð²Ð¸Ð» ${res.data.rules}, Ð¼Ð°ÑÐ¸Ð½ ${res.data.cars}, Ð½Ðµ ÑÑÐ¾Ð½ÑÑÐ¾ Ð¿ÑÐ°Ð²Ð¸Ð» ${res.data.rulesSkipped}. ÐÐ²ÑÐ¾ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ñ Ð»ÑÑÑÐµ Ð´ÐµÑÐ¶Ð°ÑÑ Ð²ÑÐºÐ»ÑÑÐµÐ½Ð½Ð¾Ð¹, Ð¸Ð½Ð°ÑÐµ ÑÐ°Ð±Ð»Ð¸ÑÐ° Ð²ÐµÑÐ½ÑÑ ÑÐµÐ½Ñ.`
      );
      load();
    } catch (err) {
      alert.error(extractErrorMessage(err) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð²ÐµÑÐ½ÑÑÑÑÑ Ðº Ð²ÐµÑÑÐ¸Ð¸');
    } finally {
      setBusy(false);
    }
  };

  const toggleAuto = async () => {
    const next = !settings.autoSync;
    if (next && !ask('auto')) return;
    setBusy(true);
    try {
      const res = await setSheetAutoSync(next);
      setSettings(res.data);
      alert.success(next ? 'ÐÐ²ÑÐ¾ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ñ Ð²ÐºÐ»ÑÑÐµÐ½Ð°' : 'ÐÐ²ÑÐ¾ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ñ Ð²ÑÐºÐ»ÑÑÐµÐ½Ð°');
    } catch (err) {
      alert.error(extractErrorMessage(err) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¿ÐµÑÐµÐºÐ»ÑÑÐ¸ÑÑ Ð°Ð²ÑÐ¾ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ñ');
    } finally {
      setBusy(false);
    }
  };

  // ÐÑÐ¸ Ð¿Ð¾Ð¸ÑÐºÐµ Ð¾ÑÑÐ°ÑÑÑÑ Ð·Ð°Ð¿ÑÑÐºÐ¸, Ð³Ð´Ðµ ÐµÑÑÑ Ð¿Ð¾Ð´ÑÐ¾Ð´ÑÑÐ°Ñ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ, Ð¸ Ð² Ð½Ð¸Ñ â ÑÐ¾Ð»ÑÐºÐ¾ Ð¾Ð½Ð°
  const visible = useMemo(() => {
    if (!runs) return [];
    const q = query.trim();
    if (!q) return runs;
    return runs
      .map((r) => ({ ...r, changes: r.changes.filter((c) => matchesFilter(c, q)) }))
      .filter((r) => r.changes.length > 0);
  }, [runs, query]);

  if (loading && !runs) return <div className={styles.empty}>ÐÐ°Ð³ÑÑÐ·ÐºÐ°â¦</div>;

  return (
    <>
      <AutoSyncPanel settings={settings} busy={busy} onToggle={toggleAuto} confirming={confirm?.kind === 'auto'} />

      <details className={styles.help}>
        <summary>ÐÐ°Ðº Ð¾ÑÐºÐ°ÑÑÐ²Ð°ÑÑÑÑ</summary>
        <ul>
          <li>
            <b>ÐÑÐºÐ°ÑÐ¸ÑÑ</b> â Ð¾ÑÐ¼ÐµÐ½ÑÐµÑ ÑÐ¾Ð»ÑÐºÐ¾ ÑÑÐ¾Ñ Ð·Ð°Ð¿ÑÑÐº: Ð¿ÑÐ°Ð²Ð¸Ð»Ð° Ð¸ ÑÐµÐ½Ñ Ð¼Ð°ÑÐ¸Ð½, ÐºÐ¾ÑÐ¾ÑÑÐµ Ð¾Ð½ Ð¼ÐµÐ½ÑÐ», Ð²Ð¾Ð·Ð²ÑÐ°ÑÐ°ÑÑÑÑ Ðº Ð¿ÑÐµÐ¶Ð½Ð¸Ð¼.
            ÐÑÐ»Ð¸ ÑÐµÐ½Ñ Ð¿Ð¾ÑÐ¾Ð¼ Ð¸Ð·Ð¼ÐµÐ½Ð¸Ð»Ð¸ ÐµÑÑ ÑÐ°Ð· (Ð²ÑÑÑÐ½ÑÑ Ð¸Ð»Ð¸ Ð´ÑÑÐ³Ð¸Ð¼ Ð·Ð°Ð¿ÑÑÐºÐ¾Ð¼), ÐµÑ Ð½Ðµ ÑÑÐ¾Ð³Ð°ÐµÐ¼.
          </li>
          <li>
            <b>ÐÐµÑÐ½ÑÑÑ Ðº Ð²ÐµÑÑÐ¸Ð¸</b> â Ð¾ÑÐ¼ÐµÐ½ÑÐµÑ Ð²ÑÐµ Ð·Ð°Ð¿ÑÑÐºÐ¸ Ð¿Ð¾ÑÐ»Ðµ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð³Ð¾, Ð¾Ñ Ð½Ð¾Ð²ÑÑ Ðº ÑÑÐ°ÑÑÐ¼. ÐÑÐ±ÑÐ°Ð½Ð½ÑÐ¹ Ð·Ð°Ð¿ÑÑÐº Ð¾ÑÑÐ°ÑÑÑÑ:
            ÑÐµÐ½Ñ Ð¸ Ð¿ÑÐ°Ð²Ð¸Ð»Ð° ÑÑÐ°Ð½Ð¾Ð²ÑÑÑÑ ÑÐ°ÐºÐ¸Ð¼Ð¸, ÐºÐ°ÐºÐ¸Ð¼Ð¸ Ð±ÑÐ»Ð¸ ÑÑÐ°Ð·Ñ Ð¿Ð¾ÑÐ»Ðµ Ð½ÐµÐ³Ð¾.
          </li>
          <li>
            Ð¡Ð°Ð¼Ð° Google-ÑÐ°Ð±Ð»Ð¸ÑÐ° Ð¿ÑÐ¸ Ð¾ÑÐºÐ°ÑÐµ Ð½Ðµ Ð¼ÐµÐ½ÑÐµÑÑÑ. ÐÐ¾ÑÑÐ¾Ð¼Ñ Ð¿Ð¾ÑÐ»Ðµ Ð²Ð¾Ð·Ð²ÑÐ°ÑÐ° Ðº ÑÑÐ°ÑÐ¾Ð¹ Ð²ÐµÑÑÐ¸Ð¸ Ð´ÐµÑÐ¶Ð¸ÑÐµ Ð°Ð²ÑÐ¾ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ñ
            Ð²ÑÐºÐ»ÑÑÐµÐ½Ð½Ð¾Ð¹, Ð° ÑÑÑÐ½Ð¾Ð¹ Â«ÐÑÐ¸Ð¼ÐµÐ½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸ÑÂ» Ð½Ðµ Ð½Ð°Ð¶Ð¸Ð¼Ð°Ð¹ÑÐµ, Ð¿Ð¾ÐºÐ° Ð½Ðµ Ð¿Ð¾Ð¿ÑÐ°Ð²Ð¸ÑÐµ ÑÐ°Ð±Ð»Ð¸ÑÑ.
          </li>
        </ul>
      </details>

      <div className={styles.top}>
        <input
          className={styles.filter}
          placeholder="ÐÐ¾Ð¸ÑÐº Ð¿Ð¾ Ð¼Ð¾Ð´ÐµÐ»Ð¸, Ð¼Ð°ÑÐºÐµ Ð¸Ð»Ð¸ ID ÑÑÑÐ¾ÐºÐ¸"
          aria-label="ÐÐ¾Ð¸ÑÐº Ð¿Ð¾ Ð¸ÑÑÐ¾ÑÐ¸Ð¸"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <span className={styles.muted}>ÐÐ°Ð¿ÑÑÐºÐ¸ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸ ÑÐ°Ð±Ð»Ð¸ÑÑ, Ð½Ð¾Ð²ÑÐµ ÑÐ²ÐµÑÑÑ. ÐÐ¾ÐºÐ° ÑÐ°Ð±Ð»Ð¸ÑÐ° Ð½Ðµ Ð¼ÐµÐ½ÑÐ»Ð°ÑÑ, Ð¿ÑÐ¾Ð²ÐµÑÐºÐ° Ð² Ð¸ÑÑÐ¾ÑÐ¸Ñ Ð½Ðµ Ð¿Ð¸ÑÐµÑ.</span>
      </div>

      {visible.length === 0 && (
        <div className={styles.empty}>{query.trim() ? `ÐÐ¾ Ð·Ð°Ð¿ÑÐ¾ÑÑ Â«${query}Â» Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½Ð¾` : 'ÐÐ°Ð¿ÑÑÐºÐ¾Ð² ÐµÑÑ Ð½Ðµ Ð±ÑÐ»Ð¾'}</div>
      )}

      {visible.map(({ run: r, author, changes }) => {
        const id = r.id;
        const isOpen = open.has(id) || !!query.trim();
        const later = laterRollbackable(runs, id);
        return (
          <div className={styles.run} key={id}>
            <div className={styles.runHead} onClick={() => toggle(id)}>
              <span className={styles.runWhen}>{formatDateTime(r.startedAt)}</span>
              <span className={styles.kind}>{STATUS_LABELS[r.status] || r.status}</span>
              <span>{author || (r.trigger === 'schedule' ? 'Ð°Ð²ÑÐ¾' : '')}</span>
              <span className={styles.muted}>{summarizeRun(r)}</span>
              <span className={styles.grow} />
              {r.revertedAt && <span className={styles.reverted}>Ð¾ÑÐºÐ°ÑÐµÐ½ {formatDateTime(r.revertedAt)}</span>}
              {canRollback(r) && later > 0 && (
                <button
                  type="button"
                  className={confirm?.kind === 'to' && confirm.id === id ? styles.miniDanger : styles.mini}
                  disabled={busy}
                  title={`ÐÑÐ¼ÐµÐ½Ð¸ÑÑ Ð²ÑÐµ Ð·Ð°Ð¿ÑÑÐºÐ¸ Ð¿Ð¾ÑÐ»Ðµ ÑÑÐ¾Ð³Ð¾ (${later}) Ð¸ Ð²ÐµÑÐ½ÑÑÑ Ð¿ÑÐ°Ð²Ð¸Ð»Ð° Ð¸ ÑÐµÐ½Ñ Ðº ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ñ ÑÑÐ°Ð·Ñ Ð¿Ð¾ÑÐ»Ðµ Ð½ÐµÐ³Ð¾`}
                  onClick={(e) => {
                    e.stopPropagation();
                    rollbackTo(id);
                  }}
                >
                  {confirm?.kind === 'to' && confirm.id === id ? `ÐÑÐºÐ°ÑÐ¸ÑÑ Ð·Ð°Ð¿ÑÑÐºÐ¾Ð²: ${later}?` : 'ÐÐµÑÐ½ÑÑÑ Ðº Ð²ÐµÑÑÐ¸Ð¸'}
                </button>
              )}
              {canRollback(r) && (
                <button
                  type="button"
                  className={confirm?.kind === 'run' && confirm.id === id ? styles.miniDanger : styles.mini}
                  disabled={busy}
                  title="ÐÑÐ¼ÐµÐ½Ð¸ÑÑ ÑÐ¾Ð»ÑÐºÐ¾ ÑÑÐ¾Ñ Ð·Ð°Ð¿ÑÑÐº"
                  onClick={(e) => {
                    e.stopPropagation();
                    rollback(id);
                  }}
                >
                  {confirm?.kind === 'run' && confirm.id === id ? 'ÐÑÐºÐ°ÑÐ¸ÑÑ Ð·Ð°Ð¿ÑÑÐº?' : 'ÐÑÐºÐ°ÑÐ¸ÑÑ'}
                </button>
              )}
            </div>
            {isOpen && (
              <div className={styles.runBody}>
                {r.message && <div className={styles.hint}>{r.message}</div>}
                {changes.length === 0 ? (
                  <div className={styles.empty}>Ð ÑÑÐ¾Ð¼ Ð·Ð°Ð¿ÑÑÐºÐµ Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð¼ÐµÐ½ÑÐ»Ð¾ÑÑ</div>
                ) : (
                  <table className={styles.table}>
                    <thead>
                      <tr>
                        <th>Ð§ÑÐ¾</th>
                        <th>ÐÐ°ÑÐºÐ°</th>
                        <th className={styles.num}>ÐÑÐ»Ð¾</th>
                        <th className={styles.num}>Ð¡ÑÐ°Ð»Ð¾</th>
                        <th className={styles.num}>Ð Ð°Ð·Ð½Ð¸ÑÐ°</th>
                        <th>ÐÑÐ¸Ð¼ÐµÑÐ°Ð½Ð¸Ðµ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {changes.map((c) => (
                        <tr key={c.id}>
                          <td>
                            <span className={kindClass(c.kind)}>{KIND_LABELS[c.kind] || c.kind}</span> <b>{c.sheetKey}</b>{' '}
                            {c.label}
                          </td>
                          <td>{c.mark}</td>
                          <td className={`${styles.num} ${styles.was}`}>{money(c.oldPrice)}</td>
                          <td className={`${styles.num} ${styles.now}`}>{money(c.newPrice)}</td>
                          <td className={`${styles.num} ${isBigJump(c.oldPrice, c.newPrice) ? styles.deltaBig : ''}`}>
                            {c.kind === 'problem' ? '' : deltaText(c.oldPrice, c.newPrice)}
                          </td>
                          <td className={styles.muted}>{c.note}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

export default SheetHistory;
